import { createFileRoute, Link } from "@tanstack/react-router"
import { IconPenFill18 } from "nucleo-ui-fill-18"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { Button } from "@/components/ui/button"
import { ApprovalSettings } from "@/features/settings/components/approval-settings"
import { PrincipalPermissions } from "@/features/settings/components/principal-permissions"
import { useCan } from "@/hooks/use-organisation"
import { firmRecordQueries } from "@/queries/firm-record"
import { permissionQueries } from "@/queries/permissions"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/settings/organisation/authorisation/"
)({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(firmRecordQueries.permissions()),
      context.queryClient.ensureQueryData(permissionQueries.groups()),
    ]),
  component: AuthorisationSettingsPage,
})

function AuthorisationSettingsPage() {
  const canManage = useCan("manage_settings")

  return (
    <>
      <PageHeader
        title="Authorisation"
        actions={
          <Button
            variant="outline"
            disabled={!canManage}
            nativeButton={false}
            render={
              <Link
                from="/$organisation"
                to="/$organisation/settings/organisation/authorisation/activities"
              >
                <IconPenFill18 data-icon="inline-start" />
                Change activities
              </Link>
            }
          />
        }
      />
      <PageContent>
        <PrincipalPermissions />
        <ApprovalSettings />
      </PageContent>
    </>
  )
}
